import { render, staticRenderFns } from "./MultiForm.vue?vue&type=template&id=33eacfc2&scoped=true&"
import script from "./MultiForm.vue?vue&type=script&lang=js&"
export * from "./MultiForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33eacfc2",
  null
  
)

export default component.exports